module.exports = __webpack_public_path__ + "static/thumbnail-resume-c7d67d3b94c47ec817fe4f12a006ef7a.jpg";